import { Typography, Box } from '@mui/material';
import React from 'react';
import BarChartBasic from '../../components/charts/BarChartBasic';
import { dataset, xAxis, series } from '../../content/BasicBarChartData';

const VesselSchedulePage = (props) => {
    return (
        <>
            <Box sx={{ p: 5 }}>
                <Typography variant={'h2'}>Vessel Schedule</Typography>
                {/* Display the BasicBarChart component */}
                <BarChartBasic dataset={dataset} xAxis={xAxis} series={series} label="Rainfall (mm)" height={400}/>
            </Box>
        </>
    );
};

export { VesselSchedulePage };